import { Autocomplete as BaseAutocomplete } from '@base-ui/react/autocomplete';

// TODO: please refactor and make a good wrapper

export const Autocomplete = BaseAutocomplete;
